import { Link } from 'react-router-dom';

import arrow from '../../assets/images/icons/arrow.svg';
import { Container } from './styles';

interface PageHeaderInterface {
  title: string | JSX.Element;
  link?: string;
  status?: string;
  statusColor?: 'green' | 'orange' | 'gray' | 'red';
  statusRot?: string;
}

export default function PageHeader({ title, link, status, statusColor, statusRot }: PageHeaderInterface) {
  const smallTagRenderByStatusRot: { [key: string]: JSX.Element } = {
    Implantado: <small className='green'>Implantado</small>,
    Otimizado: <small className='green'>Otimizado</small>,
    'Não Otimizado': <small className='orange'>Não Otimizado</small>,
    'Acima do Teto': <small className='orange'>Acima do Teto</small>,
    'Acima do Valor': <small className='orange'>Acima do Valor</small>,
    'Sem Resultado': <small className='red'>Sem Resultado</small>,
    'Fora de Abrangência': <small className='red'>Fora de Abrangência</small>,
    'Caminhada a pé': <small>Caminhada a pé</small>,
    'Em processamento': <small>Em processamento</small>,
    'Sem Status': <small className='gray'>Sem Status</small>,
  };

  return (
    <Container>
      {!!link && (
        <Link to={link}>
          <img src={arrow} alt="back" className="primaryColor" />
          <span>Voltar</span>
        </Link>
      )}
      {!!title && (
        <h1>
          {title}
          {!!status && (
            <small className={statusColor}>{status}</small>
          )}

          {!!statusRot && smallTagRenderByStatusRot[statusRot]}
        </h1>
      )}
    </Container>
  );
}
